import React from 'react';
import { IQueryContext } from 'framework/context/IQueryContext';
import { IQueryResult, IReturn, IReturnsQueryParams } from 'gen/ApiClient';

export const ReturnsQueryContext = React.createContext<IQueryContext<IQueryResult<IReturn>, IReturnsQueryParams>>(undefined as any);
